/**
 * Polls backend for the current user's profile photo URL and updates
 * the settings page avatar once Lambda + webhook have finished.
 */

async function fetchPhotoUrl() {
  const resp = await fetch('/account/profile/photo-url/', {
    method: 'GET',
    cache: 'no-store',
    credentials: 'same-origin',
    headers: {
      'Accept': 'application/json',
    },
  });

  if (!resp.ok) {
    throw new Error('Failed to fetch profile photo URL');
  }

  return resp.json();
}

function withVersion(url, version) {
  if (!url || !version) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${encodeURIComponent(version)}`;
}

export function initProfilePhotoPoll() {
  const img = document.getElementById('settings-profile-photo');
  if (!img) return;

  let currentVersion = img.dataset.photoVersion || '';
  let attempts = 0;
  const maxAttempts = 8;
  const intervalMs = 2000;

  const timer = setInterval(async () => {
    attempts += 1;

    try {
      const data = await fetchPhotoUrl();
      const nextVersion = data.photo_version || '';
      const versionChanged = Boolean(nextVersion) && nextVersion !== currentVersion;
      const photoBaseUrlChanged =
        Boolean(data.photo_url) &&
        img.src !== data.photo_url &&
        !img.src.startsWith(`${data.photo_url}?`) &&
        !img.src.startsWith(`${data.photo_url}&`);

      if (data.photo_url && (versionChanged || photoBaseUrlChanged)) {
        img.src = withVersion(data.photo_url, nextVersion);
        currentVersion = nextVersion;
        img.dataset.photoVersion = nextVersion;
        clearInterval(timer);
        return;
      }
    } catch (e) {
      // best-effort; ignore errors and try again until maxAttempts
    }

    if (attempts >= maxAttempts) {
      clearInterval(timer);
    }
  }, intervalMs);
}

